/**
 * Human names and symbols for the currencies this bundle ships.
 *
 * Shared by Balances and Overview (#140) rather than copied — both list the
 * same accounts and had begun to disagree about what to call them.
 *
 * DELIBERATELY a lookup with a fallback to the code, and NOT the closed set
 * `money.ts` keeps. That asymmetry is the same one `decodeAccount` makes: the
 * closed table exists so an unknown SCALE is never guessed at, and getting a
 * scale wrong is a figure a factor of ten out that looks correct. A missing
 * NAME costs the customer the word "Euro" and shows them "EUR", which is not
 * wrong — so falling back here is right where falling back there would not be.
 */
export const CURRENCY_NAME: Record<string, string> = {
  EUR: 'Euro',
  GBP: 'British pound',
  USD: 'US dollar',
  CHF: 'Swiss franc',
  SEK: 'Swedish krona',
  NOK: 'Norwegian krone',
  DKK: 'Danish krone',
  PLN: 'Polish złoty',
  CZK: 'Czech koruna',
  RON: 'Romanian leu',
  BGN: 'Bulgarian lev',
  HUF: 'Hungarian forint',
}

export const CURRENCY_SYMBOL: Record<string, string> = {
  EUR: '€',
  GBP: '£',
  USD: '$',
  CHF: '₣',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  CZK: 'Kč',
  HUF: 'Ft',
}
